module.exports = "img/icon-context-mute-mentions.266796b.svg";